import { Box, Typography } from '@mui/material';

import { EmptyStateBoxProps } from './EmptyStateBox.types';

export default function EmptyStateBox({
  title,
  subtitle,
  icon,
  primaryButton,
  secondaryButton,
  ...props
}: EmptyStateBoxProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      textAlign="center"
      flexDirection="column"
      gap={2}
      borderRadius={1}
      {...props}
    >
      {icon ?? null}
      <Typography variant="h5" fontWeight="fontWeightBold">
        {title}
      </Typography>
      {subtitle ? <Typography variant="body1">{subtitle}</Typography> : null}
      <Box width="100%" display="flex" flexDirection="column" gap={1.5}>
        {primaryButton ?? null}
        {secondaryButton ?? null}
      </Box>
    </Box>
  );
}
